module.exports = "<svg viewBox=\"0 0 78.1 78.1\"><path fill=\"none\" stroke=\"#000\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" stroke-width=\"14\" d=\"M7 7l64.1 64.1m0-64.1L7 71.1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/cross.svg
// module id = 233
// module chunks = 1